import {ReactSVG} from "react-svg";
import React from "react";
import {Translation} from "react-i18next";

const OptionsMenu = (props) => {
  const isFreeEvent = JSON.parse(localStorage.getItem('eventInfo'))?.eventsite_payment_setting?.eventsite_billing === 0;

  React.useEffect(() => {
    document.body.addEventListener("click", handleBodyClick);
    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, []);

  const handleBodyClick = (e) => {
    // Check if click is inside a dropdown container
    const clickedElement = e.target;
    const dropdownContainer = clickedElement.closest(".dropdown");

    // Only close dropdowns if clicking outside all dropdown containers
    if (!dropdownContainer) {
      const btnDots = document.querySelectorAll(".btn_dots");
      btnDots.forEach((btn) => {
        if (btn.classList.contains("active")) {
          btn.classList.remove("active");
        }
      });
    }
  };

  const handleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Remove active class from all other btn_dots
    const btnDots = document.querySelectorAll(".btn_dots");
    btnDots.forEach((btn) => {
      if (btn !== e.target) {
        btn.classList.remove("active");
      }
    });

    // Toggle active class on the clicked button
    e.target.classList.toggle("active");
  };

    return (
        <Translation>
            {
                t => (
                    <div className="grid-8">
                        <div className="parctical-button-panel button-panel-list">
                            <div className="dropdown">
                                <span onClick={(e) => handleDropdown(e)} className="btn btn_dots">
                                        <ReactSVG style={{pointerEvents: 'none'}} wrapper="span" className='icons' alt={t('ACCESSIBILITY_MORE')} src={require("img/ico-dots-gray.svg")} />
                                </span>
                                <div className="dropdown-menu">
                                    <button className="dropdown-item" onClick={(e) => props.handleChange(e, props.order, "send_offer")}>
                                        {t('G_SEND_OFFER')}
                                    </button>
                                    {isFreeEvent && (
                                        <button className="dropdown-item" onClick={(e) => props.handleChange(e, props.order, "assign_manually")}>
                                            {t('G_ASSIGN_MANUALLY')}
                                        </button>
                                    )}
                                    <button className="dropdown-item" onClick={(e) => props.handleChange(e, props.order, "delete_order")}>
                                        {t('G_DELETE')}
                                    </button>
                                    <button className="dropdown-item" onClick={(e) => props.handleChange(e, props.order, "reject_order")}>
                                       {t('WAITING_LIST_ORDERS_REJECT_ORDER')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </Translation>

    )
}

export default OptionsMenu